import React from 'react';
import { HomePageLayout } from '../components/Layout/HomePageLayout';

const Index = (props) => {
  return <HomePageLayout {...props} />;
};

export default Index;
